const state = {
    employment_details: {}
};

const getters = {
    employmentDetailsState: (state) => state.employment_details,
};

const actions = {
    async doGetEmploymentDetails({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            axios.get("/user/" + userId + "/details/employment").then(
                (response) => {
                    commit("setEmploymentDetails", response.data);
                    resolve(response.data);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUpdateEmploymentDetails({ commit, rootState }, employmentDetails) {
        if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
        this.throttle = setTimeout(() => {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                axios.patch("/user/" + userId + "/details/employment", employmentDetails).then(
                    (response) => {
                        commit("setEmploymentDetails", response.data);
                        resolve(response.data);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }, 500);
    },
};
const mutations = {
    setEmploymentDetails: (state, employmentDetails) => {
        state.employment_details = employmentDetails;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
